import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { LoanwordComponent } from './loanword.component';


const routes: Routes = [
  {
    path: 'loanword',
    component: LoanwordComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class LoadwordRoutingModule {}
